import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ItembudgetCategory } from '../models/item-budget-category.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ItenGroupService {
  private _apiUrl = environment.apiUrl + "/v1/ItemParaOrcamento";

  constructor(private http: HttpClient) { }

  createitem(item: ItembudgetCategory): Observable<ItembudgetCategory> {
    const payload: any = { 
      grupoid: item.grupoId || null, 
      nome: item.nome || '',
      valor: item.valor ? parseFloat(String(item.valor)) : 0,
      metroQuadrado: item.metroQuadrado !== undefined && item.metroQuadrado !== null 
        ? parseFloat(String(item.metroQuadrado)) 
        : 0,
      metroQuadradoAdicional: item.metroQuadradoAdicional !== undefined && item.metroQuadradoAdicional !== null 
        ? parseFloat(String(item.metroQuadradoAdicional)) 
        : 0
    };

    return this.http.post<ItembudgetCategory>(`${this._apiUrl}`, payload)
  }

  updateItem(item: any): Observable<ItembudgetCategory> {

    const payload: any = { 
      grupoid: item.grupoId || null, 
      nome: item.nome || '',
      valor: item.valor ? parseFloat(String(item.valor)) : 0,
      metroQuadrado: item.metroQuadrado !== undefined && item.metroQuadrado !== null 
        ? parseFloat(String(item.metroQuadrado)) 
        : 0,
      metroQuadradoAdicional: item.metroQuadradoAdicional !== undefined && item.metroQuadradoAdicional !== null 
        ? parseFloat(String(item.metroQuadradoAdicional)) 
        : 0
    };

    return this.http.put<ItembudgetCategory>(`${this._apiUrl}/${item.id}`, payload)
  }

  excluirItem(item: ItembudgetCategory): Observable<ItembudgetCategory> {
    
    return this.http.delete<ItembudgetCategory>(`${this._apiUrl}/${item.id}`)
  }

  // Retorna lista de Itens Para Orçamento
  listarItemParaOrcameto(): Observable<ItembudgetCategory[]> {
    return this.http.get<ItembudgetCategory[]>(`${this._apiUrl}`);
  }
}
